export default {
  "@sparky/framework": "~0.0.59",
  "@sparky/webpack-cra": "0.7.0-beta.7",
  "react": "17.0.2",
  "react-dom": "17.0.2",
  "react-is": "17.0.2",
  "react-intl": "6.7.2",
  "history": "4.10.1",
  "lodash": "4.17.21",
  "lodash-es": "4.17.21",
  "redux": "4.2.0",
  "react-redux": "7.2.8",
  "prop-types": "15.8.1",
  "date-fns": "2.30.0",
  "moment": "2.30.1",
  "classnames": "2.3.1",
  "i18next": "20.6.1",
  "i18next-icu": "2.0.3",
  "react-hook-form": "7.44.3",
  "react-table": "7.8.0",
  "core-js": "3.41.0",
  "react-router": "5.3.4",
  "react-router-dom": "5.3.4",
  "react-router-dom-v5-compat": "6.29.0",
  "zod": "3.24.1",
  "oidc-client-ts": "3.1.0",
  "regenerator-runtime": "0.14.1",
  "eventemitter3": "4.0.7",
  "rc-tree": "5.6.7",
  "react-focus-on": "3.9.4",
  "urn-lib": "2.0.0",
  "@panwds/design": "0.7.0",
  "@panwds/icons": "7.6.9",
  "@panwds/react-filters[v9]": "9.13.3",
  "@panwds/react-form[v9]": "9.13.2",
  "@panwds/react-nav[v9]": "2.2.1",
  "@panwds/react-table[v9]": "9.13.2",
  "@panwds/react-ui[v9]": "9.13.2",
  "@panwds/tailwindcss[v9]": "13.5.2",
  "@panwds/typography": "0.10.0",
  "@sparky/material-ui": "4.11.4-bundle.0",
  "@sparky/panwds-legacy": "1.6.108",
  "@panwds/react-filters[legacy]": "1.6.1",
  "@panwds/react-form[legacy]": "1.2.2",
  "@panwds/react-table[legacy]": "1.2.1",
  "@panwds/react-ui[legacy]": "1.6.0",
  "@panwds/tailwindcss[legacy]": "6.2.0",
  "@sparky/panwds-tw-scoped-css": "11.4.0-1101-10130-1030-1020-843-620-alpha",
  "@sparky/panwds-v8": "8.25.2-6134-543-653-1140-bundle.0",
  "@panwds/react-filters[v8]": "6.13.4",
  "@panwds/react-form[v8]": "5.4.3",
  "@panwds/react-table[v8]": "6.5.3",
  "@panwds/react-ui[v8]": "8.25.2",
  "@panwds/tailwindcss[v8]": "11.4.0",
  "@sparky/reactstrap": "8.4.1-bundle.0",
  "@sparky/rum-sdk": "0.1.5",
  "@sparky/token-manager": "22.0.2"
};
